/**
 * H8: tapping the heatmap key flips and keeps the toggle; holding it flips the heatmap only while held.
 * The key is remappable through keyboard_shortcuts.bindings[SEEN_AREA_BINDING].
 */
export const HOLD_TAP_MS = 250;
export const SEEN_AREA_BINDING = 'seen_area_heatmap';
export const DEFAULT_SEEN_AREA_KEY = 'H';
/** Letters no other viewer shortcut uses (B, C, I, R, Z, G and the Q/W/E/T presets are taken). */
export const SEEN_AREA_KEY_CHOICES = ['H', 'J', 'K', 'M', 'N', 'U', 'V', 'Y'];

export const getSeenAreaKey = (keyboardShortcuts) => {
    const key = keyboardShortcuts?.bindings?.[SEEN_AREA_BINDING];
    return SEEN_AREA_KEY_CHOICES.includes(key) ? key : DEFAULT_SEEN_AREA_KEY;
};

export const isSeenAreaKey = (eventCode, keyboardShortcuts) => eventCode === `Key${getSeenAreaKey(keyboardShortcuts)}`;

export class HoldToggle {
    constructor({persistent = false, tapMs = HOLD_TAP_MS} = {}) {
        this.persistent = persistent;
        this.tapMs = tapMs;
        this._downAt = null;
    }

    get visible() {
        return this._downAt == null ? this.persistent : !this.persistent;
    }

    /** Returns true when `visible` changed. Auto-repeat and a second keydown while held are ignored. */
    keyDown(now, repeat = false) {
        if (repeat || this._downAt != null) return false;
        this._downAt = now;
        return true;
    }

    keyUp(now) {
        if (this._downAt == null) return false;
        const tapped = now - this._downAt < this.tapMs;
        this._downAt = null;
        if (tapped) this.persistent = !this.persistent;
        return !tapped;
    }

    /** Focus lost while held: revert as if the key was held and released. */
    cancel() {
        if (this._downAt == null) return false;
        this._downAt = null;
        return true;
    }

    setPersistent(value) {
        const before = this.visible;
        this.persistent = !!value;
        return before !== this.visible;
    }
}
